import React, { useEffect } from 'react'
import UpdateDevicesMethods from './updateDevices.local.methods'
import UpdateDevicesToolbar from './__toolbar/updateDevices__toolbar'
import Content from 'blocks.app/content/content'
import EditText from 'blocks.simple/editText/editText'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import { SelectTime } from 'blocks.app/scheduleSettings/scheduleSettings'
import Link from 'blocks.simple/link/link'
import Button from 'blocks.simple/button/button'
import Catalog from 'blocks.app/catalog/catalog'
import ScrollUp from 'blocks.simple/scrollUp/scrollUp'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import styles from './updateDevices.jcss'
import { grid } from '../../theme'
import { cn } from 'ethcss'
import moment from 'moment'
import { changeFilter, routes } from 'features/routes'
import { Steps } from 'atoms/Steps/Steps-view'
import { Typography } from 'atoms/Typography'
import { getURLSearchParamsString, getURLSearchParamsByLocation } from 'features/routes/utils'
import { changeLocation } from 'features/routes'
import { checkAvailableModule } from '../../core/helpers/routes/routes'
import Dropdown from '../../blocks.simple/dropdown/dropdown'
import { UpdateQueue } from './__updateQueue/UpdateQueue'

interface IProps {
    location: {
        pathname: string
        search: string
        hash: string
        state: any
    }
    updateType: string
}

const getDisplayPlatformName = (platform: string) => {
    switch (platform) {
        case 'sssp':
            return 'SSSP 2/3/4/5/6/7/10'
        case 'brightsign':
            return 'BRIGHTSIGN'
        case 'android':
            return 'Android'
        case 'tizen':
            return 'TIZEN 7'
        default:
            return 'WebOS 2/3/3.2/4/4.1/6'
    }
}

const UpdateDevices = (p_: IProps) => {
    const {
        state,
        setState,
        changeTab,
        timeOptions,
        updateNowDevice,
        onUpdate,
        onQueueSelect,
        onSelectAll,
        onSelectTask,
        onCancelSelect,
    } = UpdateDevicesMethods(p_)
    const s_ = state
    const query = getURLSearchParamsByLocation(p_.location)
    const updateType = query.updateType || 'devicesForUpdate'

    const afterLoadAction = () => {
        changeLocation({
            pathname: `/${routes.displays.path}/updateDevices`,
            search: getURLSearchParamsString({
                displays__filterList: `[{"name":"hasUpdate","type":"select","options":[{"value":null,"label":"null","selected":false},{"value":false,"label":"withUpdate","selected":true}]}]`,
            }),
        })
    }

    useEffect(() => {
        const updateFilterString =
            s_.updateType === 'client_app'
                ? `[{"name":"hasUpdate","type":"select","options":[{"value":null,"label":"null","selected":false},{"value":false,"label":"withUpdate","selected":true}]}]`
                : `[{"name":"hasNewFirmware","type":"select","options":[{"value":null,"label":"null","selected":false},{"value":false,"label":"withUpdate","selected":true}]}]`

        changeLocation({
            pathname: `/${routes.displays.path}/updateDevices`,
            search: getURLSearchParamsString({
                displays__filterList: updateFilterString,
                forceUpdate: 'true',
            }),
        })
    }, [s_.updateType])

    return (
        <Content
            title={translate('updateDevices')}
            toolbar={
                <UpdateDevicesToolbar
                    selectedItems={updateType === 'devicesForUpdate' ? s_.selectedItems : s_.selectedQueue}
                    selectedTask={s_.selectedTask}
                    onChange={(selectedItems: any[]) => {
                        if (updateType !== 'devicesForUpdate') {
                            onSelectAll(selectedItems)

                            return
                        }

                        const data: any = {
                            selectedItems,
                        }
                        if (s_.task && !selectedItems.length) {
                            data.task = null
                        }
                        setState((prevState) => {
                            return { ...prevState, ...data }
                        })
                    }}
                    onCancelSelect={onCancelSelect}
                    updateType={updateType}
                />
            }
        >
            <div className={styles.wrapper}>
                <div className={updateType === 'tasksForUpdate' ? styles.stepsWrapper : ''}>
                    <Steps active={updateType} className={styles.tabs}>
                        {s_.types.map((updateItem: { id: number | string; name: string }, index: number) => (
                            <Link
                                id={updateItem.id}
                                key={`devicesUpdateTab_${index}`}
                                to={{
                                    pathname: p_.location.pathname,
                                    search: getURLSearchParamsString({ updateType: updateItem.id }),
                                }}
                                onClick={() => {
                                    if (typeof updateItem.id === 'string') {
                                        changeTab(updateItem.id)
                                    }
                                }}
                            >
                                {updateItem.name}
                            </Link>
                        ))}
                    </Steps>
                </div>
                {updateType === 'devicesForUpdate' && (
                    <div>
                        <Typography type="text" className={cn(styles.title, grid.mb_mdPlus)}>
                            {translate('updateParams')}
                        </Typography>
                        <div className={styles.updateDevicesQueue}>
                            <EditText
                                label={translate('queueName')}
                                value={s_.name}
                                onChange={(name: string) => {
                                    setState((prevState) => {
                                        return { ...prevState, name }
                                    })
                                }}
                            />
                        </div>
                        <div className={styles.settings}>
                            <div className={styles.updateDevicesUpdateDateWrapper}>
                                <EditText
                                    label={translate('updateDate')}
                                    dateValue={s_.updateNow ? null : s_.startDate.toString()}
                                    disabled={s_.updateNow}
                                    id={'startDate'}
                                    type="date"
                                    onChange={(startDate: string) => {
                                        setState((prevState) => {
                                            return { ...prevState, startDate }
                                        })
                                    }}
                                />
                            </div>
                            <SelectTime
                                time={{
                                    label: translate('updateTime'),
                                    id: 'startTime',
                                    type: 'text',
                                    mask: '99:99:99',
                                    value: s_.updateNow ? undefined : s_.startTime,
                                    disabled: s_.updateNow,
                                    mod: 'darkBlue',
                                    containerClassName: styles.updateDevicesUpdateTimeWrapper,
                                }}
                                timeOptions={timeOptions}
                                onChange={(value: string) => {
                                    if (moment(value, 'HH:mm:ss', true).isValid()) {
                                        setState((prevState) => {
                                            return { ...prevState, startTime: value, editingMode: true }
                                        })
                                    }
                                }}
                            />
                            <div className={styles.updateDevicesUpdateNowCheckboxWrapper}>
                                <Checkbox
                                    label={translate('updateNow')}
                                    className={cn(styles.updateDevicesUpdateNowCheckbox, 'test-update-now')}
                                    checked={s_.updateNow}
                                    onClick={updateNowDevice}
                                />
                            </div>
                            <div className={styles.updateDevicesRow}>
                                <div className={styles.updateDevicesCol} style={{ marginBottom: '20px' }}>
                                    <EditText
                                        label={translate('maxDigitalSignageCount')}
                                        value={s_.maxDigitalSignageCount ?? ''}
                                        type="number"
                                        onChange={(val: string) => {
                                            const maxDigitalSignageCount = val.replace(/^0+(?!$)/, '')
                                            setState((prev) => ({
                                                ...prev,
                                                maxDigitalSignageCount,
                                            }))
                                        }}
                                    />
                                </div>
                                <div className={styles.updateDevicesCol}>
                                    <EditText
                                        label={translate('updateTimeout')}
                                        value={s_.updateTimeout}
                                        type={'number'}
                                        onChange={(val: string) => {
                                            const updateTimeout = val.replace(/^0+(?!$)/, '')
                                            setState((prevState) => {
                                                return { ...prevState, updateTimeout }
                                            })
                                        }}
                                    />
                                    <div className={styles.help}>{translate('minimumValue')}: 10</div>
                                </div>
                            </div>
                            <div style={{ width: '100%' }}>
                                <div className={styles.updateTypeWrapper}>
                                    <Dropdown
                                        label={translate('updateType')}
                                        value={s_.updateType}
                                        options={[
                                            { id: 'client_app', name: translate('client_app') },
                                            { id: 'firmware', name: translate('firmware') },
                                        ]}
                                        onChange={(selected) => {
                                            setState((prevState) => {
                                                return { ...prevState, updateType: selected.id }
                                            })
                                        }}
                                        className={styles.updateType}
                                    />
                                </div>
                            </div>
                            <div className={styles.updateDevicesUpdateButtonWrapper}>
                                <Button mod={'fill'} onClick={onUpdate} disabled={!s_.name || !s_.selectedItems.length}>
                                    {translate('createUpdateQueue')}
                                </Button>
                            </div>
                        </div>
                        <Typography type="text" className={styles.title}>
                            {translate('selectDevicesForUpdate')}
                        </Typography>
                        <div className={cn(grid.p_mdPlus, grid.pt_md)}>
                            <Catalog
                                searchbarMod={'withShadow'}
                                key={'catalog_displays'}
                                type={'displays'}
                                //filterOptions={s_.updateType === 'client_app' ? { hasUpdate2: true } : { hasNewUpdate: true }}
                                selectedItems={s_.selectedItems}
                                onSelect={(selectedItems: object[]) => {
                                    setState((prevState) => {
                                        return { ...prevState, selectedItems }
                                    })
                                }}
                                afterLoadAction={afterLoadAction}
                            />
                        </div>
                    </div>
                )}
                {updateType === 'tasksForUpdate' && (
                    <div className={styles.tasksList}>
                        <UpdateQueue
                            selectedQueue={s_.selectedQueue}
                            onQueueSelect={onQueueSelect}
                            onSelectAll={onSelectAll}
                            selectedTask={s_.selectedTask}
                            onSelectTask={onSelectTask}
                            onCancelSelect={onCancelSelect}
                        />
                        {/*<Catalog*/}
                        {/*    hideHeader*/}
                        {/*    searchbarMod={'withShadow'}*/}
                        {/*    key={'catalog_tasks'}*/}
                        {/*    type={'tasks'}*/}
                        {/*    selectedItems={s_.selectedItems}*/}
                        {/*    onSelect={(selectedItems: object[]) => {*/}
                        {/*        setState((prevState) => {*/}
                        {/*            return { ...prevState, selectedItems }*/}
                        {/*        })*/}
                        {/*    }}*/}
                        {/*    onEditListItem={(task: { digitalSignage: object }) => {*/}
                        {/*        setState((prevState) => {*/}
                        {/*            return { ...prevState, selectedItems: [task.digitalSignage], task: task }*/}
                        {/*        })*/}

                        {/*        let search = getURLSearchParamsString({*/}
                        {/*            updateType: 'devicesForUpdate',*/}
                        {/*        })*/}

                        {/*        changeLocation({*/}
                        {/*            pathname: `/${routes.updateDevices.path}`,*/}
                        {/*            search,*/}
                        {/*        })*/}
                        {/*    }}*/}
                        {/*    selectAllCheckbox={true}*/}
                        {/*/>*/}
                    </div>
                )}
            </div>
            <ScrollUp />
        </Content>
    )
}

const exportUpdateDevices = checkAvailableModule('displays/updateDevices') ? UpdateDevices : null

export default exportUpdateDevices
